<template>
  <div class="row">
    <div class="col col-md-6 h2">
      {{ headingText }}
    </div>
    <div class="col-auto col-md-6 align-self-center" v-if="buttonText || icon">
      <NavItem
        class="float-right"
        :icon="icon"
        :text="buttonText"
        :iconOnRight="true"
        @click="$emit('click', $event)"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import NavItem from '@/web/components/navigation/NavItem';

export default Vue.extend({
  components: {
    NavItem,
  },
  props: {
    headingText: {
      type: String,
      default: null,
    },
    buttonText: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
